export default __webpack_public_path__ + "static/media/logo-bg1.dc55d1a0.png";